/* eslint-disable no-case-declarations */
import { FEATURE_TYPES, NOTEABLE_TYPES } from './constants'

export const getFeatureDisplayString = (ghType) => {
	let displayString = 'Feature'
	switch (ghType) {
		case FEATURE_TYPES.Point:
			displayString = 'Waypoint'
			break
		case FEATURE_TYPES.Polyline:
			displayString = 'Line'
			break
		case FEATURE_TYPES.Polygon:
			displayString = 'Area'
			break
		case FEATURE_TYPES.Tracks:
			displayString = 'Tracks'
			break
	}

	return displayString
}
export const getFormattedShareType = (grantableType) => {
	let formattedType = grantableType
	if (grantableType == NOTEABLE_TYPES.Collection) {
		formattedType = 'Hunt'
	} else if (grantableType == NOTEABLE_TYPES.Feature) {
		formattedType = 'Feature'
	}

	return formattedType
}
/* 
	* #TODO: Remove after all user preference records have been migrated
	* Temporary user preference until all deprecated records are migrated over to the new model
		- 11-02-22 JT
*/
// export const setVisibleFeaturesOnLoad = (params) => {
// 	const { featuresList = [], deprecated } = params
// 	const payloads = []
// 	const visibleFeatures = []

// 	if (deprecated.hiddenFeatures?.length > 0) {
// 		for (let fli = 0; fli < featuresList.length; fli++) {
// 			if (!deprecated.hiddenFeatures.includes(featuresList[fli].uuid)) {
// 				visibleFeatures.push(featuresList[fli].id)
// 			}
// 		}
// 	} else if (deprecated.recentlyAddedFeatures?.length > 0) {
// 		visibleFeatures.push(...deprecated.recentlyAddedFeatures)
// 	}
// 	if (visibleFeatures.length) {
// 		payloads.push({ features: visibleFeatures, type: 'feature', visibility: true })
// 	}

// 	return payloads
// }

export const setVisibleFeaturePayloads = (params) => {
	const { featuresList, payload, preferences } = params
	const hiddenFeatures = []
	const visibleFeatures = []
	const payloads = []
	let featureId = null

	if (payload.featureIds.length) {
		if (!preferences.visible.features.length) {
			if (!payload.visibility) {
				for (let fli = 0; fli < featuresList.length; fli++) {
					featureId = featuresList[fli].id
					if (!payload.featureIds.includes(featureId)) {
						visibleFeatures.push(featureId)
					}
				}
			} else {
				for (let fli = 0; fli < featuresList.length; fli++) {
					featureId = featuresList[fli].id
					if (payload.featureIds.includes(featureId)) {
						visibleFeatures.push(featureId)
					}
				}
			}
		} else {
			if (!payload.visibility) {
				for (let fli = 0; fli < featuresList.length; fli++) {
					featureId = featuresList[fli].id
					if (payload.featureIds.includes(featureId)) {
						hiddenFeatures.push(featureId)
					}
				}
			} else {
				for (let fli = 0; fli < featuresList.length; fli++) {
					featureId = featuresList[fli].id
					if (payload.featureIds.includes(featureId)) {
						visibleFeatures.push(featureId)
					}
				}
			}
		}
	}

	if (visibleFeatures.length) {
		payloads.push({ features: visibleFeatures, type: 'feature', visibility: true })
	}
	if (hiddenFeatures.length) {
		payloads.push({ features: hiddenFeatures, type: 'feature', visibility: false })
	}

	return payloads
}
